import styled from 'styled-components';

export const FeatureCardWrapper = styled.div<{ isClickable: boolean }>`
  cursor: ${props => (props.isClickable ? 'pointer' : 'auto')};

  [class*='Headingstyle__Heading-sc'] {
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }
`;

export const TitleWrapper = styled.div`
  [class*='Headingstyle__Heading-sc'] {
    font-family: 'Vodafone';
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    margin: 10px 78px;

    @media only screen and (max-width: 767px) {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      margin: 0;
    }
  }
`;

export const Label = styled.div`
  position: absolute;
  z-index: 99;
  margin: 16px;
  background-color: #00697C;
  color: #FFFFFF;
  padding: 0px 12px;
  border-radius: 13px;
  width: fit-content;
  height: fit-content;

  span {
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
  }
`;
